import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import Toast from 'components/Toast';

export default class MultipleDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.setAnswers(),
      selectedOption: i18n.translate('trainingScreens.choose'),
      answerFeedback: '',
      toastContent: null,
    };
  }

  setAnswers() {
    const { answer } = this.props;
    const dropdown = [
      <option hidden value="" key="option_default">
        {i18n.translate('questions.dropdown')}
      </option>,
    ];
    dropdown.unshift(
      <option key={`option_${Date.now()}`} value={i18n.translate('questions.dropdown')}>
        {i18n.translate('questions.dropdown')}
      </option>,
    );
    answer.forEach((answerText) => {
      dropdown.push(
        <option value={answerText} key={answerText}>
          {answerText}
        </option>,
      );
    });
    return dropdown;
  }

  checkAnswer(e) {
    const { value } = e.target;
    // eslint-disable-next-line no-unused-vars
    const { answer, answersCorrect, contentComplete, correctAnswerText, error, incorrectAnswerText } = this.props;
    this.setState({ selectedOption: value });
    if (
      value.length > 0 &&
      (answersCorrect[answer.indexOf(value)] === 'true' || answersCorrect[answer.indexOf(value)] === true)
    ) {
      this.setState({
        answerFeedback: 'correct',
        toastContent: {
          position: 'top-center',
          content: correctAnswerText,
        },
      });
      contentComplete();
    } else {
      this.setState({
        answerFeedback: 'wrong',
        toastContent: {
          type: 'error',
          position: 'top-center',
          content: incorrectAnswerText,
        },
      });
      error(true);
    }
  }

  render() {
    const { disableHeader, error, question, disableToast } = this.props;

    const { options, selectedOption, answerFeedback, toastContent } = this.state;

    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content multipleDropdown">
          <h4>{question}</h4>
          <div className={`select__Container ${answerFeedback}`}>
            <select value={selectedOption} onChange={(e) => this.checkAnswer(e)}>
              {options}
            </select>
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {error(false)}
        </div>
      </div>
    );
  }
}

MultipleDropdown.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  answersCorrect: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func.isRequired,
  correctAnswerText: PropTypes.string,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  error: PropTypes.func,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
};

MultipleDropdown.defaultProps = {
  correctAnswerText: '',
  incorrectAnswerText: '',
  error: () => {},
  disableHeader: false,
  disableToast: false,
};
